import { render, staticRenderFns } from "./supplier-note.vue?vue&type=template&id=08d7df2a"
import script from "./supplier-note.vue?vue&type=script&lang=js"
export * from "./supplier-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports